import { useOrganization } from '@/hooks/useOrganization';
import { useAuthStore } from '@/stores/authStore';

type Role = 'admin' | 'manager' | 'cashier' | 'accountant';
const ADMIN = 'admin';
const MANAGER = 'manager';
const CASHIER = 'cashier';
const ACCOUNTANT = 'accountant';

export function useHasRole() {
  const { currentMembership } = useOrganization();
  const activeOperator = useAuthStore((s) => s.activeOperator);
  const simpleOperatorRole: Role | null =
    activeOperator?.type === 'simple_user'
      ? activeOperator.role ?? CASHIER
      : null;
  const simpleOperator = simpleOperatorRole !== null;

  const hasRole = (role: Role): boolean => {
    if (simpleOperator) {
      return simpleOperatorRole === role;
    }
    return currentMembership?.role === role;
  };

  const hasAnyRole = (roles: Role[]): boolean => {
    if (simpleOperator) {
      return simpleOperatorRole !== null && roles.includes(simpleOperatorRole);
    }
    if (!currentMembership) return false;
    return roles.includes(currentMembership.role);
  };

  return {
    hasRole,
    hasAnyRole,
    isAdmin: () => hasRole(ADMIN),
    isManager: () => hasRole(MANAGER),
    isCashier: () => hasRole(CASHIER),
    isAccountant: () => hasRole(ACCOUNTANT),
    isAdminOrManager: () => hasAnyRole([ADMIN, MANAGER]),
    currentRole: simpleOperatorRole ?? currentMembership?.role,
  };
}
